import React, { SyntheticEvent } from 'react';
import { connect } from 'react-redux';
import { Mode } from '../models/commonEnums';
import { Store } from '../reducers';
import styles from './ViewWrapper.module.scss';

type WithChildren<T = Record<string, unknown>> = T & { children: React.ReactNode };

export const Header1 = ({ children }: WithChildren): JSX.Element => <h1 className={styles.header1}>{children}</h1>;

type FormWrapperType = WithChildren & { onSubmit: (e: SyntheticEvent<HTMLFormElement>) => void; testAttr: string };

export const FormWrapper = ({ children, onSubmit, testAttr }: FormWrapperType): JSX.Element => (
    <form className={styles.formBody} onSubmit={onSubmit} {...{ [`data-${testAttr}`]: true }}>
        {children}
    </form>
);

const ViewWrapper = ({ children, mode }: WithChildren & { mode: Mode }): JSX.Element => (
    <div className={styles[mode]}>{children}</div>
);

const mapStateToProps = (state: Store): { mode: Mode } => {
    const {
        user: { mode },
    } = state;
    return {
        mode,
    };
};

export default connect(mapStateToProps)(ViewWrapper);
